<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span v-if="!value.id"> {{ $t('create_blacklist_number_form_title') }} </span>
                    <span v-else> {{ $t('update_blacklist_number_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            v-model="value.number"
                            :rules="[rules.required,rules.to]"
                            :label="$t('number')"
                    ></v-text-field>
                    <v-checkbox
                            v-model="value.block_outgoing_fax"
                            :label="$t('block_outgoing_fax')"
                            type="checkbox"
                    ></v-checkbox>

                    <v-checkbox
                            v-model="value.block_incoming_fax"
                            :label="$t('block_incoming_fax')"
                            type="checkbox"
                    ></v-checkbox>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('send_request')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import { required, to} from '@/scripts/validationRules';
    import Service from "../services/BlacklistNumbersService";

    export default {
        props: {
            item : {
                required: true
            }
        },
        computed : {
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                showPass : false,
                value : {...this.item},
                rules: {
                    required,
                    to
                },

            }
        },
        methods: {

            async submit() {
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');
            }
        }
    }
</script>